import React from 'react';
import { IndexRoute, Route } from 'react-router';
import BuyPoints from './buyPoints';

export default (
  <Route path="buy">
    <IndexRoute component={props => <BuyPoints {...props} />} />
  </Route>
);
